import { useCompanyRelativePath } from 'ogp/hooks';
import { ServiceAgreementsResponse } from 'ogp/services/service-agreements.types';
import { routes } from 'Routes';
import { AgreementCard } from './agreement-card';

export const SupplierCard = ({
  serviceAgreement,
}: {
  serviceAgreement: ServiceAgreementsResponse[number];
}) => {
  const generatePath = useCompanyRelativePath();

  return (
    <AgreementCard
      id={serviceAgreement.id}
      title={serviceAgreement.lenderServiceAgreementParty.name}
      to={generatePath(routes.ServiceAgreementDetail, { id: serviceAgreement.id })}
    />
  );
};
